import { render } from "./CandidateList.vue?vue&type=template&id=406194a9&scoped=true"
import script from "./CandidateList.vue?vue&type=script&lang=js"
export * from "./CandidateList.vue?vue&type=script&lang=js"

import "./CandidateList.vue?vue&type=style&index=0&id=406194a9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406194a9"]])

export default __exports__